export type StripeSubscriptionStatus =
  | 'active'
  | 'canceled'
  | 'incomplete'
  | 'incomplete_expired'
  | 'past_due'
  | 'paused'
  | 'trialing'
  | 'unpaid'

export type BillingSubscriptionStatus = StripeSubscriptionStatus | 'inactive'

export const INACTIVE_BILLING_STATUS: BillingSubscriptionStatus = 'inactive'

const VALID_BILLING_STATUSES = new Set<BillingSubscriptionStatus>([
  INACTIVE_BILLING_STATUS,
  'active',
  'canceled',
  'incomplete',
  'incomplete_expired',
  'past_due',
  'paused',
  'trialing',
  'unpaid',
])

const SUBSCRIPTION_ACCESS_STATUSES = new Set<BillingSubscriptionStatus>([
  'active',
  'trialing',
])

const FEATURE_ROLE_PREFIX = 'FEATURE_'

export function normalizeBillingStatus(
  value: unknown
): BillingSubscriptionStatus {
  if (typeof value !== 'string') {
    return INACTIVE_BILLING_STATUS
  }

  const normalized = value.toLowerCase() as BillingSubscriptionStatus
  return VALID_BILLING_STATUSES.has(normalized)
    ? normalized
    : INACTIVE_BILLING_STATUS
}

export function isTrialingStatus(status: string | undefined | null): boolean {
  return normalizeBillingStatus(status) === 'trialing'
}

export function hasSubscriptionAccess(
  status: string | undefined | null
): boolean {
  return SUBSCRIPTION_ACCESS_STATUSES.has(normalizeBillingStatus(status))
}

export function shouldBypassStripeFlow(
  status: string | undefined | null,
  roles: string[] = []
): boolean {
  const normalizedStatus = normalizeBillingStatus(status)

  return (
    !hasSubscriptionAccess(normalizedStatus) &&
    roles.some((role) => role.startsWith(FEATURE_ROLE_PREFIX))
  )
}

export function hasBillingAccess(
  status: string | undefined | null,
  roles: string[] = []
): boolean {
  return hasSubscriptionAccess(status) || shouldBypassStripeFlow(status, roles)
}
